<template>
  <div id="app">
    <!--    <transition :name="transitionName">-->
    <router-view :key="key"></router-view>
    <!--    </transition>-->
  </div>
</template>

<script>
import DevicePixelRatio from './utils/devicePixelRatio';

export default {
  name: 'App',
  data() {
    return {
      transitionName: '',
      appZoom: '',
    }
  },
  updated() {
    window.scroll(0, 0);
  },
  created() {
    new DevicePixelRatio().init(); // 显示器缩放
    this.screenWidth = document.body.clientWidth; //屏幕尺寸
    // 实现浏览器随意缩放
    this.$nextTick(() => {
      this.resizeFun()
      window.addEventListener('resize', this.resizeFun)
    })
    if (this.screenWidth < "1920" && this.screenWidth > "1440") {
      // if (!!window.ActiveXObject || "ActiveXObject" in window) {
      document.write(
        '<body style="zoom: 0.8;">'
      );
    } else if (this.screenWidth <= "1440" && this.screenWidth > "1280") {
      document.write(
        '<body style="zoom: 0.7;">'
      );
    }
  },
  watch: {//使用watch 监听$router的变化
    $route(to, from) {
    }
  },
  computed: {
    key() {
      return this.$route.path + Math.random()
    }
  },
  methods: {
    resizeFun() {
      const devicePixelRatio = window.devicePixelRatio // 获取下载的缩放 125% -> 1.25    150% -> 1.5
      if (devicePixelRatio !== 1) {
        // 如果在笔记本中用 IE 浏览器打开 则弹出提示
        if (!!window.ActiveXObject || 'ActiveXObject' in window) {
          console.log('IE 浏览器打开')
        } else {
          if(this.screenWidth > 1280) {
            const c = document.querySelector('body')
            c.style.zoom = 1 / devicePixelRatio// 修改页面的缩放比例
          }
        }
      }
    }
  }
}
</script>

<style>
@import "assets/css/common.less";
.router {
  width: 100px;
  height: 100px;
  font-size: 32px;
  color: #000b12;
  background: #FFFFFF;
}
/*移动端*/
@media screen and (max-width: 1280px) {
  #app {
    font-family: SourceHanSansCN-Regular;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
}

@media screen and (min-width: 980px) {
  .slide-right-enter-active,
  .slide-right-leave-active,
  .slide-left-enter-active,
  .slide-left-leave-active {
    will-change: transform;
    transition: all 500ms;
    position: absolute;
  }

  .slide-right-enter {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  .slide-right-leave-active {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }

  .slide-left-enter {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }

  .slide-left-leave-active {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  #app {
    font-family: SourceHanSansCN-Regular;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue